import { render, staticRenderFns } from "./CreateModal.vue?vue&type=template&id=ac84f166&scoped=true&"
import script from "./CreateModal.vue?vue&type=script&lang=js&"
export * from "./CreateModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateModal.vue?vue&type=style&index=0&id=ac84f166&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac84f166",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ac84f166')) {
      api.createRecord('ac84f166', component.options)
    } else {
      api.reload('ac84f166', component.options)
    }
    module.hot.accept("./CreateModal.vue?vue&type=template&id=ac84f166&scoped=true&", function () {
      api.rerender('ac84f166', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/organization/services/CreateModal.vue"
export default component.exports